// extracted by mini-css-extract-plugin
export default {"weekList":"weeks-list_weekList__AqqSJ"};